<template lang="pug">
  div#nav
    v-container(text-xs-center)
      v-layout(row wrap justify-center)
        v-flex(xs5)
          v-btn(
            block
            outline
            large
            to="/asesorías"
            class="mr-2"
            v-bind:class="path == 'advisory' ? 'btn-black' : 'btn-white'"
          ) Asesorías
        v-flex(xs5)
          v-btn(
            block
            outline
            large
            to="/víctimas"
            class="ml-2"
            v-bind:class="path == 'advisory' ? 'btn-white' : 'btn-black'"
          ) Víctimas
      v-layout.mt-4(row wrap justify-center)
        v-flex(xs11 sm10 md8)
          p.large.mb-0 {{ path == 'advisory' ? adviseText : victimsText }}
          hr.navigation.mt-2(align="center"
        )

</template>

<script>
export default {
  name: "Navigation",
  data () {
    return {
      adviseText: 'Filtra por el lugar o asunto de la asesoría, así como la edad, sexo u ocupación de la persona a la que se le brindó asesoría.',
      victimsText: 'Filtra los casos de desaparición asesorados por el Centro Fray Juan de Larios según las características de las víctimas.'
    };
  },
  computed: {
    path() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles.scss';

#nav {
  background-color: #fff;
  .btn-white {
    font-family: "Open Sans", sans-serif;
    border-radius: 7px;
    font-weight: 900;
    text-transform: capitalize;
    font-size: 25px;
    height: 56px;
    background-color: #fff !important;
    color: black !important;
    border-color: black !important;
  }
  .btn-white:hover {
    background-color: $accent-color !important;
    border-color: transparent;
    color: #fff;
    opacity: 0.8;
  }
  .btn-black:hover {
    background-color: $accent-color !important;
    border-color: transparent !important;
    color: #fff !important;
    opacity: 0.8;
  }
  .btn-black {
    color: #fff !important;
    font-family: "Open Sans", sans-serif;
    border-radius: 7px;
    font-weight: 900;
    text-transform: capitalize;
    font-size: 25px;
    height: 56px;
    background-color: black !important;
  }
  .navigation {
    width: 30%;
    display: inline-block;
    border: 1.5px solid $main-color;
  }
}
</style>
